import {IValueLabel} from "../../variables/types/IValueLabel";

export const findVariableByValue = (variables: IValueLabel[] = [], value: number): IValueLabel | null => {
    return variables.find((variable) => variable.value === value) || null;
};
import {IValueLabel} from "../../variables/types/IValueLabel";

export const findVariableByValue = (variables: IValueLabel[] = [], value: number): IValueLabel | null => {
    return variables.find((variable) => variable.value === value) || null;
};
